import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, map, filter } from 'rxjs';
import { getisLoggedIn, getAuthMeError, getToken } from '@/app/store/auth/auth.selector';
import { loadMe } from '@/app/store/auth/auth.actions';
import { AuthenticationService } from '@/app/core/services/config/auth.service';
import { VerticalMenuButtonComponent } from '@/app/components/menu/components/menu-button';
import { NotificationDropdownComponent } from '@/app/components/top-bar/notification-dropdown/notification-dropdown.component';
import { ProfileDropdownComponent } from '@/app/components/top-bar/profile-dropdown/profile-dropdown.component';
import { RouterOutlet, RouterLink } from '@angular/router';
import { NgbCollapseModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AppMenuComponent } from 'src/app/components/menu/menu';
import { LogoBoxComponent } from 'src/app/components/logo-box/logo-box.component';
import { bookingHomeMenuItems } from '../../../assets/data';
import { FooterComponent } from '@/app/components/footer/footer.component';
import { SupportWidgetComponent } from '@/app/components/support-widget/support-widget.component';
import { QuickActionsBarComponent } from '@/app/components/top-bar/quick-actions-bar/quick-actions-bar.component';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [
    CommonModule,
    AppMenuComponent,
    NgbDropdownModule,
    LogoBoxComponent,
    NgbCollapseModule,
    VerticalMenuButtonComponent,
    NotificationDropdownComponent,
    ProfileDropdownComponent,
    RouterOutlet,
    RouterLink,
    FooterComponent,
    QuickActionsBarComponent,
    SupportWidgetComponent,
  ],
  templateUrl: './default-layout.html',
  styleUrl: './default-layout.scss',
})
export class DefaultLayout implements OnInit {
  bookingHomeMenuItems = bookingHomeMenuItems;
  isCollapsed = true;
  showNavbar = true;
  isScrolled = false;

  isLoggedIn$!: Observable<boolean>;
  token$!: Observable<string | undefined>;
  authShellVisible$!: Observable<boolean>;
  hasCookieSession!: boolean;
  private meError$!: Observable<unknown>;
  logoScrollThreshold = 200;

  private readonly landingsWithOwnNavbar = [
    '/landing/viaja-con-arcadia',
    '/landing/madrid-ccs',
    '/landing/bogota-madrid',
    '/landing/cartagena-madrid',
    '/landing/bucaramanga-madrid',
    '/landing/cali-madrid',
    '/landing/medellin-madrid',
    '/landing/barranquilla-madrid',
    '/landing/cucuta-madrid',
    '/landing/financiamiento',
    '/canton-2027',
    '/canton27',
  ];

  constructor(
    private store: Store,
    private authService: AuthenticationService,
    private router: Router,
  ) {
    this.isLoggedIn$ = this.store.select(getisLoggedIn);
    this.token$ = this.store.select(getToken);
    this.meError$ = this.store.select(getAuthMeError);

    this.authShellVisible$ = combineLatest([this.isLoggedIn$, this.token$, this.meError$]).pipe(
      map(
        ([isLoggedIn, token, meError]) =>
          isLoggedIn && (!!token || !!this.authService.session) && meError == null,
      ),
    );

    this.hasCookieSession = !!this.authService.session;

    if (this.authService.session) {
      this.store.dispatch(loadMe());
    }
  }

  private shouldShowNavbar(url: string): boolean {
    return !this.landingsWithOwnNavbar.some((path) => url.includes(path));
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 120;
  }

  ngOnInit(): void {
    const setThreshold = (url: string) => {
      this.logoScrollThreshold = url.startsWith('/news-arcadia') ? 1 : 200;
    };

    setThreshold(this.router.url);
    this.showNavbar = this.shouldShowNavbar(this.router.url);

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        setThreshold(e.urlAfterRedirects);
        this.showNavbar = this.shouldShowNavbar(e.urlAfterRedirects);
      });
  }
}